import OrderHeaderFieldsetController from "emun.order/order-header-fieldset.controller.es6";
import AutoQuery from "servicestack/auto-query/auto-query";

export default class OneCoastOrderHeaderFieldsetController extends OrderHeaderFieldsetController {
	constructor($scope, $session) {
		super($scope, $session);

		const $ctrl = this;

		if ($ctrl.$session.isVendor() && $ctrl.orderConfig.virtualSources.findIndex(x => x.id=="Direct") < 0) {
			$ctrl.orderConfig.virtualSources.push({ id: "Direct", label: "DIRECT" });
		}

	}

	loadQueries() {
		let $ctrl = this;
	
		super.loadQueries();
		$ctrl.vendors = new AutoQuery({
		  url: "QueryVendors.json?Active=1",
		  orderBy: "Label",
		  autoLoad: true,
		  pageSize: 100
		});
	  }

}
